import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useIsLocating } from "../utils/getPositionWithFallback";

const LocatingPill = () => {
  const { t } = useTranslation();
  const locating = useIsLocating();
  if (!locating) return null;
  return (
    <Box role="status" aria-live="polite" sx={{
      position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)",
      display: "flex", alignItems: "center", gap: 1, px: 2, py: 0.8,
      borderRadius: "20px", backgroundColor: "rgba(255,255,255,0.95)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.25)", pointerEvents: "none", zIndex: 2600,
    }}>
      <CircularProgress size={16} />
      <span style={{ fontSize: 13, fontFamily: "Poppins, sans-serif", color: "#2C384C" }}>
        {t("fetchingLocation") || "Fetching your location..."}
      </span>
    </Box>
  );
};
export default LocatingPill;
